import React from "react";
import { Button, Stack } from "react-bootstrap";

interface InlineConfirmState {
  question?: string;
  detail?: string;
  confirmText?: string;
  // destructive by default - a move or other ordinary action should pass "secondary"
  confirmColor?: "danger" | "secondary";
  onConfirm: any;
  onCancel: any;
}

// The confirm-in-place pattern used all over housing: the question in bold, then Confirm and
// Cancel with the divider between them. Kept in one place so the wording, the weight and the
// divider stay identical everywhere instead of being rebuilt per card.
const InlineConfirm = ({ question, detail, confirmText = "Confirm", confirmColor = "danger", onConfirm, onCancel }: InlineConfirmState) => {
  return (
    <Stack direction="horizontal" gap={2} className="align-items-center flex-wrap">
      {(question || detail) && (
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          {question && <div className="small fw-bold">{question}</div>}
          {detail && <div className="small text-muted">{detail}</div>}
        </div>
      )}
      <Button
        size="sm"
        className={confirmColor === "danger" ? "app-danger-color button flex-shrink-0" : "app-secondary-color button flex-shrink-0"}
        onClick={onConfirm}
      >
        {confirmText}
      </Button>
      <div className="vr" />
      <Button size="sm" className="app-primary-color button flex-shrink-0" onClick={onCancel}>
        Cancel
      </Button>
    </Stack>
  );
};

export default InlineConfirm;
